import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { TimePicker, Select as CustomSelect } from "antd";
import { defaultLogo } from "../env";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import { checkHtmlAndLengthValidation, INVALID_CHARS_REGEX, userSearch } from "../utils/validation";
import { CloseIcon, FileIcon, FillCloseIcon, LeftArrow } from "../Assets/iconshere";
import { debounce } from "../utils/useWindowDimensions";
import apiClient from "../apiClient";
import { getExactError } from "../utils/general.js";
const currentTime = new Date();

export const allowedMimeTypes = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "video/mp4",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "gltf",
  "glb",
];

export let validationError = {
  name: null,
  description: null,
  environmentId: null,
  startTime: null,
  endTime: null,
  invalid: null,
};

export let allowedFileType = ".png, .jpg, .jpeg, .mp4, .pdf, .glb, .gltf";

const CreateEvent = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);

  const navigate = useNavigate();
  const dropAreaRef = useRef(null);
  const myFileRef = useRef(null);
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [guestEmails, setGuestEmails] = useState([]);
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [showList, setShowList] = useState(false);
  const [name, setName] = useState("");
  const [environmentId, setEnvironmentId] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState(moment(currentTime).toDate());
  const [endDate, setEndDate] = useState(moment(currentTime).toDate());
  const [startTime, setStartTime] = useState(moment().format("HH:mm:ss"));
  const [endTime, setEndTime] = useState(moment(currentTime).add(5, "minutes").format("HH:mm:ss"));
  const [type, setType] = useState("PUBLIC");
  const [uploadFiles, setUploadFiles] = useState([]);
  const [selectText, setSelectText] = useState("--Select Environment--");
  const [saveBtnText, setSaveBtnText] = useState("Create");
  const [fileError, setFileError] = useState(null);
  const [error, setError] = useState(validationError);
  const [eventFileTags, setEventFileTags] = useState(configData?.config?.eventFileTags || []);
  const [additionalFields, setAdditionalFields] = useState([]);

  useEffect(() => {
    let _fields = configData?.config?.additionalInfo?.map((e) => ({ ...e, value: "" })) || [];
    setAdditionalFields(_fields);
  }, [configData?.config?.additionalInfo]);

  const handleCancel = () => {
    setName("");
    setEnvironmentId("");
    setDescription("");
    setEndDate(new Date());
    setStartTime(moment().format("LT"));
    setEndDate(new Date());
    setEndTime(null);
    setUploadFiles([]);
    setSelectText('"--Select Environment--"');
    navigate("/events");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    handleFileChange(files);
  };
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragEnter = () => {
    dropAreaRef.current.classList.add("drag-over");
  };

  const handleDragLeave = () => {
    dropAreaRef.current.classList.remove("drag-over");
  };

  const handleChangeStartTime = (time) => {
    if (time === null) {
      return;
    }

    const formattedTime = time.format("HH:mm");

    setError({ ...error, date: null });
    setStartTime(formattedTime);
  };

  const handleChangeEndTime = (time) => {
    if (time === null) {
      return;
    }

    const formattedTime = time.format("HH:mm");

    setError({ ...error, date: null });
    setEndTime(formattedTime);
  };

  const changeTimeFormate = (date, time) => {
    const startDateComponent = moment(date).format("YYYY-MM-DD");
    const startTimeComponent = moment(time, "hh:mm A").format("HH:mm:00.000");
    const mergedDateTime = moment(
      `${startDateComponent} ${startTimeComponent}`,
      "YYYY-MM-DD HH:mm:00.000"
    ).toISOString();
    return mergedDateTime;
  };

  const formatSize = (bytes) => {
    if (bytes >= 1048576) {
      return (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      return (bytes / 1024).toFixed(2) + " KB";
    } else {
      return bytes + " bytes";
    }
  };

  const getEnvironmentsList = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}/api/resource/environment/all`);

      // let { data } = await axios.get(`${configData.config.UNO_URL}/api/resource/environment/all`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });
      setList(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileChange = async (eventOrFiles) => {
    setFileError(null);
    let newFiles;
    if (eventOrFiles.target) {
      newFiles = Array.from(eventOrFiles.target.files);
    } else {
      newFiles = Array.from(eventOrFiles);
    }

    myFileRef.current.value = null;

    const validFiles = newFiles.filter(
      (file) => allowedMimeTypes.includes(file.type) || allowedMimeTypes.includes(file.name.split(".").pop())
    );

    const updatedFiles = validFiles.map((file) => {
      let _file = file.type;
      if (!_file && allowedMimeTypes.includes(file.name.split(".").pop())) _file = file.name.split(".").pop();
      let fileType;
      switch (_file) {
        case "image/jpeg":
        case "image/png":
        case "image/gif":
          fileType = "IMAGE";
          break;
        case "application/pdf":
          fileType = "PDF";
          break;
        case "video/mp4":
          fileType = "VIDEO";
          break;
        case "application/vnd.ms-powerpoint":
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation": // Modern PPTX format
          fileType = "PPT";
          break;
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": // Modern DOCX format
          fileType = "DOC";
          break;
        case "gltf":
        case "glb":
          fileType = "MODEL";
          break;
        default:
          fileType = "UNKNOWN";
      }

      return {
        file,
        name: file.name,
        size: file.size,
        progress: true,
        path: null,
        type: fileType,
        splittedImages: [],
        fileUploaded: false,
        tags: null,
        failed: false,
        errorMessage: null
      };
    });

    setUploadFiles((prevUploadFiles) => [...prevUploadFiles, ...updatedFiles]);

    try {
      await Promise.all(
        updatedFiles.map(async (file) => {
          await uploadFile(file.file);
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const { data } = await axios.post(
        `${configData.config.UNO_URL}/api/resource/environment/event/upload/asset`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return updateFileProgress(file, data, false, null);
    } catch (error) {
      console.error("File upload failed:", error);
      let exactError = getExactError(error)
      return updateFileProgress(file, "", true, exactError);
    }
  };

  const updateFileProgress = (file, data, isFailed = false, errorMessage = null) => {
    setUploadFiles((prevFiles) =>
      prevFiles.map((upload) => {
        if (upload.file === file) {
          return {
            ...upload,
            path: isFailed ? null : data.url,
            splittedImages: isFailed ? [] : data.splittedImages,
            progress: false,
            fileUploaded: isFailed ? false : true,
            failed: isFailed,
            errorMessage: errorMessage
          };
        }
        return upload;
      })
    );
  };

  const cancelUpload = (index) => {
    const updatedFiles = [...uploadFiles];
    updatedFiles.splice(index, 1);
    setUploadFiles(updatedFiles);
  };

  const validateRequired = (value, message) => {
    if (value === null || value === undefined) {
      return message;
    }
    return value.trim() === "" ? message : null;
  };

  const handleSaveEvent = async () => {
    const newStartTime = changeTimeFormate(startDate, startTime);
    const newEndTime = changeTimeFormate(endDate, endTime);

    const newErrors = {
      name: checkHtmlAndLengthValidation("Name", name, 0, 100),
      description: checkHtmlAndLengthValidation("Description", description, 0, 4000),
      environmentId: validateRequired(environmentId, "Environment is Required"),
      startTime: validateRequired(startTime, "Please select start time"),
      endTime: validateRequired(endTime, "Please select end time"),
      invalid: newStartTime >= newEndTime ? "Start time cannot exceed End time." : null,
    };

    if (Object.values(newErrors).some((value) => value !== null)) {
      setError(newErrors);
      return;
    }

    let uploadFilesList = uploadFiles.filter (e => !e.failed );

    if (configData?.config?.eventFileTags && !uploadFilesList.every((e) => e.tags)) {
      setFileError("kindly add tag with every file.");
      return;
    }

    setSaveBtnText("Processing");

    const formData = {
      name,
      description,
      environmentId,
      startTime: newStartTime,
      endTime: newEndTime,
      type,
      files: uploadFilesList.map((e) => {
        delete e.file;
        delete e.progress;
        delete e.fileUploaded;
        delete e.failed;
        delete e.errorMessage;
        return { ...e, tags: e.tags.value };
      }),
      additionalInfo: additionalFields.map((e) => ({ key: e.key, value: e.value, displayName: e.name })),
      guestEmails: guestEmails,
      users: selectedUsers.map((e) => e.uuid),
      emails: selectedUsers.map((e) => ({ name: e.name, email: e.email })),
      // emails: type === "PRIVATE"
      //         ? selectedUsers.map((e) => ({ name: e.name, email: e.email }))
      //         : userList.map((e) => ({ name: e.name, email: e.email })),
      applicationId: configData.config.applicationId,
    };

    try {
      await apiClient.post(`${configData.config.API_URL}/api/event/create`, formData);

      // await axios.post(`${configData.config.API_URL}/api/event/create`, formData, {
      //   headers: {
      //     Authorization: `Bearer ${userData?.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });
      setSaveBtnText("Saved");
    } catch (error) {
      setSaveBtnText("Save");
      console.log(error);
    } finally {
      setTimeout(() => {
        navigate("/events");
      }, 500);
    }
  };

  const handleSelectFileTag = (value, index) => {
    const selectedTag = eventFileTags.find((tag) => tag.value === value);
    let allFiles = uploadFiles.map((e, i) => (i === index ? { ...e, tags: selectedTag } : e));
    setUploadFiles(allFiles);
  };

  const handleCancelTag = (index) => {
    let allFiles = uploadFiles.map((e, i) => (i === index ? { ...e, tags: null } : e));
    setUploadFiles(allFiles);
  };

  useEffect(() => {
    getEnvironmentsList();
  }, []);

  useEffect(() => {
    setUserList(userData.channelUsers.filter((e) => e.uuid !== userData.user.uuid));
  }, [userData]);

  const handleAddNewUser = (e) => {
    if (e.key === "Enter") {
      const userEmail = e.target.value;
      const emailRegex = /^[a-z0-9][\w\.]+\@\w+?(\.\w+){1,}$/gi;
      // if (emailRegex.test(userEmail) && !userList.some((user) => user.email === userEmail)) {
      setGuestEmails((pre) => [...pre, userEmail]);
      setSearch("");
      // } else {
      //   alert("Invalid email address");
      // }
    }
  };
  const handleCancelNewUser = (email) => {
    setGuestEmails((pre) => pre.filter((e) => e !== email));
  };

  const handleSelectUser = (user) => {
    setUserList((prevUserList) => prevUserList.filter((u) => u.uuid !== user.uuid));
    setSelectedUsers([...selectedUsers, user]);
    setSearch("");
  };

  const handleAdditionalInfoChange = (e, index) => {
    const { value } = e.target;
    setAdditionalFields((prevFields) => prevFields.map((field, i) => (i === index ? { ...field, value } : field)));
  };

  const handleUpdateName = (value) => {
    if (INVALID_CHARS_REGEX.test(value)) return;
    setName(value);
    setError({ ...error, name: null });
  }

  const handleUpdateDescription = (value) => {
    if (INVALID_CHARS_REGEX.test(value)) return;
    setDescription(value);
    setError({ ...error, description: null });
  }

  const debounceHandleSaveReview = debounce(handleSaveEvent, 1000);

  let filterUserList = userList.filter((e) => userSearch(e, search));
  filterUserList = filterUserList.slice(0, 15);

  return (
    <>
      <div className="container-fluid bg-grey-main dashboard p-3 pt-2">
        <div className="createevent">
          <div className="createhead px-3">
            <div className="col-md-12 d-flex align-items-center">
              <button onClick={() => navigate(-1)} className="backbtn cursor-pointer ps-2 mb-2" title="Back">
                <LeftArrow />
                Back
              </button>
            </div>
            <h4>Create Event</h4>
            <p>Bridging Knowledge with Innovation in Every Virtual Experience</p>
          </div>
          <div className="row px-3">
            <div className="col-xl-7">
              <div className="row">
                <div className="col-md-12">
                  <div className="quesformbox mt-1">
                    <p>
                      Event Subject <span>*</span>
                    </p>
                    <input
                      name="minimumSuccess"
                      placeholder="Subject"
                      type="text"
                      className="input mt-2"
                      value={name}
                      onChange={(e) => handleUpdateName(e.target.value)}
                    />
                    <p className="error" style={{ color: "red" }}>
                      {error.name}
                    </p>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="quesformbox mt-2">
                    <p>Select Type</p>
                    <select
                      value={type}
                      className="form-select formode mt-2"
                      aria-label="Default select example"
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value={"PRIVATE"}> Private </option>
                      <option value={"PUBLIC"}> Public </option>
                    </select>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="quesformbox mt-3 date-range-parent">
                    <p>
                      Event Date & Time <span>*</span>
                    </p>
                    <div className="timemode">
                      <DatePicker
                        minDate={new Date()}
                        closeOnScroll={true}
                        selected={startDate}
                        dateFormat="dd/MM/YYYY"
                        onChange={(date) => setStartDate(moment(date).toDate())}
                      />
                      <div className="hours time-time">
                        <TimePicker
                          value={startTime ? dayjs(startTime, "HH:mm") : null}
                          format="h:mm A"
                          onChange={handleChangeStartTime}
                        />
                      </div>

                      <p style={{ color: "#000" }}>To</p>

                      <DatePicker
                        minDate={new Date()}
                        closeOnScroll={true}
                        selected={endDate}
                        dateFormat="dd/MM/YYYY"
                        onChange={(date) => setEndDate(moment(date).toDate())}
                      />
                      <div className="hours time-time">
                        <TimePicker
                          value={endTime ? dayjs(endTime, "HH:mm") : null}
                          format="h:mm A"
                          onChange={handleChangeEndTime}
                        />
                      </div>
                    </div>
                  </div>
                  <p className="error" style={{ color: "red", textAlign: "left" }}>
                    {error?.startTime || error?.endTime || error?.invalid}
                  </p>
                </div>

                <div className="col-md-12">
                  <div className="quesformbox mt-3">
                    <p>
                      Description <span>*</span>
                    </p>
                    <textarea
                      name="minimumSuccess"
                      placeholder="Description"
                      type="text"
                      rows="4"
                      className="input mt-2"
                      value={description}
                      onChange={(e) => handleUpdateDescription(e.target.value)}
                    ></textarea>
                    <p className="error" style={{ color: "red" }}>
                      {error.description}
                    </p>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="quesformbox mt-3">
                    <p style={{ fontWeight: "500" }}>Select Users</p>
                    <div className="UserBox">
                      <div className="rolelist">
                        {selectedUsers &&
                          selectedUsers.map((user, index) => {
                            let _name = user.name
                              .split(" ", 2)
                              .map((e) => e.charAt(0).toUpperCase())
                              .join("");
                            return (
                              <div key={index + 1} className="userselect">
                                {user.avatar ? (
                                  <img src={user.avatar} referrerPolicy={"no-referrer"} alt={user.name} />
                                ) : (
                                  <span className="sm-initials"> {_name} </span>
                                )}
                                <p>{user.name}</p>
                                <span
                                  onClick={() => {
                                    setUserList([...userList, user]);
                                    selectedUsers.splice(index, 1);
                                  }}
                                  className="removeuser"
                                >
                                  <CloseIcon />
                                </span>
                              </div>
                            );
                          })}

                        {guestEmails &&
                          guestEmails.map((email, index) => {
                            let name = email.split("@")[0].slice(0, 2).toUpperCase();
                            return (
                              <div key={index + 1} className="userselect">
                                <span className="sm-initials">{name}</span>

                                <p>{email}</p>
                                <span onClick={() => handleCancelNewUser(email)} className="removeuser">
                                  <CloseIcon />
                                </span>
                              </div>
                            );
                          })}

                        <div className="userselect withinput">
                          <input
                            type="text"
                            placeholder="Search & Add Users"
                            className="form-control"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onFocus={() => setShowList(true)}
                            onBlur={() => setTimeout(() => setShowList(false), 500)}
                            onKeyDown={(e) => handleAddNewUser(e)}
                          />

                          {showList ? (
                            <div className="userinputsearch">
                              {filterUserList.map((user, index) => {
                                return (
                                  <div
                                    key={index + 1}
                                    className="userserachitem "
                                    onClick={() => handleSelectUser(user)}
                                  >
                                    {user.avatar ? (
                                      <img src={user.avatar} alt={user.name} referrerPolicy={"no-referrer"} />
                                    ) : (
                                      <span className="sm-initials">
                                        {user.name.length > 0 &&
                                          user.name
                                            .split(" ", 2)
                                            .map((e) => e.charAt(0).toUpperCase())
                                            .join("")}
                                      </span>
                                    )}
                                    <p>{user.name}</p>
                                  </div>
                                );
                              })}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="quesformbox mt-3">
                    <p>
                      Select Environment <span>*</span>
                    </p>
                    <p className="error" style={{ color: "red", textAlign: "left" }}>
                      {error.environmentId}
                    </p>

                    <div className="env-select-option mt-0">
                      {list.map((item, index) => {
                        let thumbnail = item?.versions ? item?.versions[0]?.data?.thumbnail : null;

                        return (
                          <div key={item.uuid} className="env-item" onClick={() => setEnvironmentId(item.uuid)}>
                            <img
                              className={thumbnail ? "thumb" : "sim"}
                              src={thumbnail || defaultLogo}
                              onError={(e) => {
                                e.target.src = defaultLogo;
                                e.onerror = null;
                              }}
                            />
                            <span className="check-box">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={environmentId === item.uuid}
                                  // onChange={() => setEnvironmentId(item.uuid)}
                                  />
                                }
                              />
                            </span>
                            <Tooltip title={item.name}>
                              <p className="env-name">{item.name}</p>
                            </Tooltip>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5">
              {additionalFields.length > 0 && (
                <div className="row">
                  <div className="quesformbox mt-1">
                    <p>Additional Info</p>
                  </div>
                  <div className="add-info-boxes">
                    {additionalFields.map((item, index) => {
                      return (
                        <div className="quesformbox" key={index}>
                          <p>{item.name}</p>
                          <input
                            type="text"
                            name={item.key}
                            value={item.value}
                            className="input"
                            placeholder={item.name}
                            onChange={(e) => handleAdditionalInfoChange(e, index)}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              <div className="row justify-content-start">
                <div className="quesformbox mt-3">
                  <p>Event Related Files </p>
                  <div
                    ref={dropAreaRef}
                    className="dropandselect mt-2"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                  >
                    <label htmlFor="fileUpload">
                      <FileIcon />
                      <p>
                        Drag & Drop or <span> Choose file </span> to upload
                      </p>
                      <p>Accepted Files Types : PNG, JPG, MP4, PDF, GLB, GLTF</p>
                      <input
                        ref={myFileRef}
                        type="file"
                        id="fileUpload"
                        name="fileUpload"
                        onChange={handleFileChange}
                        multiple
                        accept={allowedFileType}
                      />
                    </label>
                  </div>
                  {fileError && <p className="errorMessage"> {fileError} </p>}
                </div>

                <div className="uploadfile">
                  <div className="uploadedlist">
                    {uploadFiles.map((upload, index) => {
                      return (
                        <>
                          <div key={index + 1} className="upperdiv">
                            <FileIcon />
                            <div className="uploaddata">
                              <div className="xr">
                                <div className="project_title">
                                  <div className="namehere">
                                    <span>{upload?.name}</span>
                                  </div>
                                </div>
                                <span
                                  className="cancel-btn"
                                  style={{ cursor: "pointer", lineHeight: "1" }}
                                  onClick={() => cancelUpload(index)}
                                >
                                  <FillCloseIcon />
                                </span>
                              </div>

                              {upload.progress && (
                                <>
                                  <div className=" xr mb-1">
                                    <p className="filesize">{formatSize(upload.size)} </p>
                                  </div>
                                  <div className="uploadProgressBar">
                                    <div
                                      className="progress mt-0"
                                      style={{ height: "7px", backgroundColor: "#e1e6e9" }}
                                    >
                                      <div
                                        className="progress-bar progress-bar-striped progress-bar-animated bg-danger"
                                        role="progressbar"
                                        aria-valuenow="75"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{ width: `${100}%`, height: "10px" }}
                                      ></div>
                                    </div>
                                  </div>
                                </>
                              )}

                              {upload.failed && (
                                <>
                                  <div className=" xr mb-1">
                                    <p className="error"> Failed: {upload.errorMessage} </p>
                                  </div>
                                </>
                              )}

                              <div className="d-flex mt-1">
                                {(configData?.config?.eventFileTags && !upload.progress && !(upload.failed) && upload.fileUploaded) && (
                                  <>
                                    {!upload?.tags?.value ? (
                                      <CustomSelect
                                        showSearch
                                        variant="borderless"
                                        value={upload?.tags?.value}
                                        placeholder="Select a tag"
                                        options={eventFileTags}
                                        onChange={(e) => handleSelectFileTag(e, index)}
                                      />
                                    ) : (
                                      <span className="file-tag">
                                        {upload.tags?.label}
                                        <span onClick={() => handleCancelTag(index)}>
                                          {" "}
                                          <CloseIcon />{" "}
                                        </span>
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footerbtn w-100 text-end mt-3">
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={debounceHandleSaveReview}>
            {saveBtnText}
          </Button>
        </div>
      </div >
    </>
  );
};

export default CreateEvent;
